import { ToastTranslations } from "src/models/DTO/shared/ToastTranslations";
import { ToastTypes } from "../enums/ToastTypes";

export const ErrorTranslations = {
    translate: function(stringToTranslate : string, languageToTranslate : string) : ToastTranslations {
        let stringToReturn = '';
        let toastTupeString = ToastTypes[ToastTypes.ERROR];
        ErrorTranslations.translations.forEach(translation => {
            if (stringToTranslate == translation.original && translation[languageToTranslate  as keyof typeof translation]) {
                stringToReturn = translation[languageToTranslate  as keyof typeof translation] || '';
                if (translation['type']) {
                    toastTupeString = translation['type'];
                }
            }
        })
        return {
            text: stringToReturn || stringToTranslate,
            type: toastTupeString
        }
    },

    translations:  [
        {
            original: 'The password field is required.',
            bg: 'Паролата е задължителна.'
        },
        {
            original: 'The password is incorrect.',
            bg: 'Паролата ви е грешна.'
        },
        {
            original: 'The sku field is reqiured.',
            bg: 'Въведе SKU (код на продукта)'
        },
        {
            original: 'The quantity field is reqiured.',
            bg: 'Въведете количество за дадената разновидност.'
        },
        {
            original: 'The selected email is invalid.',
            bg: 'Въвели сте невалиден имейл.'
        },
        {
            original: 'The email must be a valid email address.',
            bg: 'Въвели сте грешен формат на имейл.'
        },
        {
            original: 'The quantity to field is invalid.',
            bg: 'Въведете поле "До  количество"'
        },
        {
            original: 'The quantity from field is invalid',
            bg: 'Въведете поле "От количество"'
        },
        {
            original: 'The prices.0.price field is required.',
            bg: 'Въведете цена за 1 брой'
        },
        {
            original: 'The prices.1.price field is required.',
            bg: 'Въведете цена за 2 броя'
        },
        {
            original: 'The prices.2.price field is required.',
            bg: 'Въведете цена за 3 броя'
        },
        {
            original: 'The prices.3.price field is required.',
            bg: 'Въведете цена за 4 броя'
        },
        {
            original: 'The SKU already exists.',
            bg: 'Съществува продукт със същото SKU/код на продукт' 
        },
        {
            original: 'The category uuid field is required.',
            bg: 'Изберете категория на продукта'
        },
        {
            original: 'The brand uuid field is required.',
            bg: 'Изберете марка на продукта'
        },
        {
            original: 'The name field is required.',
            bg: 'Въведете наименувание на продукта'
        },
        {
            original: 'The sku field is required.',
            bg: 'Въведете SKU/код на продукта'
        },
        {
            original: 'The ean has already been taken.',
            bg: 'Съществува продукт със същия EAN/Баркод"'
        },
        {
            original: 'The delivery time in days field is required.',
            bg: 'Въведете срок за доставка на продукта.'
        },
        {
            original: 'The dimensions.weight field is required.',
            bg: 'Въведете тегло на продукта.'
        },
        {
            original: 'The city field is required.',
            bg: 'Въведете град.'
        },
        {
            original: 'The street name field is required.',
            bg: 'Въведете улица.'
        },
        {
            original: 'The first name field is required.',
            bg: 'Попълнете полето Име.'
        },
        {
            original: 'The last name field is required.',
            bg: 'Попълнете полето Фамилия.'
        },
        {
            original: 'The street number field is required.',
            bg: 'Въведете номер на улицата.'
        },
        {
            original: 'The mobile phone 1 field is required.',
            bg: 'Въведете телефонен номер.'
        },
        {
            original: 'The postcode field is required.',
            bg: 'Въведете пощенския код.'
        },
        {
            original: 'The mobile phone 1 field contains an invalid number.',
            bg: 'Невалидна стойност за телефонен номер.'
        },
        {
            original: 'The courier services.other options.type field is not a valid Domain\\ProductsPackaging\\Enums\\ProductPackagingCourierTypeEnum.',
            bg: 'Въведете вид куриерска услуга.'
        },
        {
            original: 'The pickup hour field is requiered when dispatch from is organisation_office.',
            bg: 'Въведете час за вземане на пратки.'
        },
        {
            original: 'The pickup hour must be a date after or equal to 09:00.',
            bg: 'Въведете час между 09:00 и 18:00'
        },
        {
            original: 'The pickup hour must be a date before or equal to 18:00.',
            bg: 'Въведете час между 09:00 и 18:00'
        },
        {
            original: 'The email has already been taken.',
            bg: 'Имейлът е вече използван.'
        },
        {
            original: 'The mobile phone 1 has already been taken.',
            bg: 'Телефонният номер е вече използван.'
        },
        {
            original: 'The company vat number must only contain letters, numbers, dashes and underscores.',
            bg: 'ДДС номерът трябва да съдържа букви и цифри.'
        },
        {
            original: 'The street number must be an integer.',
            bg: 'Въведете само числа в полето № на ул./бул.'
        },
        {
            original: 'You have already rated this product!',
            bg: 'Вече сте оценили този продукт!'
        },
        {
            original: 'Order should be delivered to make a return',
            bg: 'Продуктът трябва да бъде доставен преди да може да се върне!'
        },
        {
            original: 'The iban must be a valid International Bank Account Number (IBAN).',
            bg: 'Въведете валиден IBAN'
        },
        {
            original: 'The order has already a return request',
            bg: 'Вече има пусната заявка за връщане за поръчката.'
        },
        {
            original: 'Product unavailable',
            bg: 'Някой от продуктите вече не е наличен.'
        },
        {
            original: 'This SKU already exists in the cart',
            bg: 'Продуктът вече е добавен.',
            type: ToastTypes[ToastTypes.SUCCESS]
        }
    ]
}


